module.exports = __webpack_public_path__ + "static/media/apply-thank-img.d4b35495.webp";